<template>
  <div class="columns is-multiline  is-desktop is-mobile">

    <column size="is-12-mobile is-12-tablet is-4-desktop is-4-widescreen is-4-fullhd"></column>

  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import JobseekerAutocompleteFilter from './jobseeker-autocomplete-filter'
import Columns from '@/components/general/columns'
import Column from '@/components/general/column'

export default {
  components: {
    JobseekerAutocompleteFilter,
    Columns,
    Column
  },
  props: {
    active: {
      type: String,
      default: 'all'
    },
    tabItems: {
      type: Array,
      default: () => []
    },
    selectItems: {
      type: Array,
      default: () => []
    },
    selectedItem: {
      type: String
    },
    keyword: {
      type: String,
      default: ''
    },
    suffixes: {
      type: Array,
      default: null
    },
    showSearch: {
      type: Boolean,
      default: true
    }
  },
  filters: {
    capitalize (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  computed: {
    ...mapState('widget', [
      'jobs',
      'companies',
      'talents'
    ]),
    ...mapState('jobs', ['jobBoardsList']),
    keywordValue: {
      get () { return this.keyword },
      set (value) {
        this.$emit('update:keyword', value)
      }
    },
    selectedItemComp: {
      get () { return this.selectedItemModel || this.selectedItem },
      set (value) {
        this.$emit('select', value)
        this.selectedItemModel = value
      }
    },
    activeItem: {
      get () { return this.activeModel || this.active },
      set (value) {
        this.$emit('active', value)
        this.$emit('update:active', value)
        this.activeModel = value
      }
    },
    formSelectedJobBoards: {
      get () { return this.selectedJobBoards },
      set (value) {
        this.getFilterJobSeekers(value)
        this.selectedJobBoards = value
      }
    }
  },
  data () {
    return {
      filter: null,
      selectedItemModel: null,
      activeModel: null,
      selectedJobBoards: []
    }
  },
  methods: {
    ...mapActions('jobseekers', ['getFilterJobSeekers']),
    onNavItemClick (item) {
      this.activeItem = item
    },
    suffix (index) {
      if (!this.suffixes || this.suffixes.length <= index) { return '' }
      return `: ${this.suffixes[index]}`
    },
    getCategory (value) {
      if (value === 'all') {
        return this.$t('jobs.cateAll')
      } else if (value === 'applied') {
        return this.$t('jobs.cateApplied')
      } else if (value === 'hired') {
        return this.$t('jobs.cateHired')
      } else if (value === 'search_jobs') {
        return `Search Jobs (${this.jobs.length})`
      } else if (value === 'explore_companies') {
        return `Explore Companies (${this.companies.length})`
      } else if (value === 'Browse Talent') {
        return `Browse Talent (${this.talents.length})`
      }
      return value
    }
  }
}
</script>

<style lang="scss" scoped>
.list-nav {
  height: 40px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 24px;
  margin-bottom: 40px;

  > .field .control {
    margin-top: 0;
  }
  .flex-end-align{
    display: flex;
    align-items: flex-end;
    height: 100%;
  }

}
</style>
<style lang="css" scoped>
.mt-2{
  margin-top: 10px;
}
.full-width{
  width: 100%
}
</style>



// WEBPACK FOOTER //
// src/components/jobseekers/jobseeker-list-nav.vue